
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import "@/store/modules/common";
const commonState = namespace("Common");

import { form1StatesInfoType, form1DataInfoType } from '@/types/Information/Form1';
import { locationsInfoType } from '@/types/Common';

@Component
export default class FillForm1ManualSummaryInfo extends Vue {    

    @commonState.State
    public locationsInfo!: locationsInfoType[];

    @form1State.State
    public form1InfoStates: form1StatesInfoType;

    @form1State.State
    public form1Info: form1DataInfoType;

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void

    manualSummaryInfo = {} as form1DataInfoType;

    @Prop({required: true})
    manualNTrib!: boolean

    @Prop({required: true})
    manualTrib!: boolean

    @Prop({required: true})
    manualNorm!: boolean
    
    dataReady = false;    
    tribunalTypes = [    
        {
            label: 'Tribunal',
            options: [
                "British Columbia Utilities Commission",    
                "Building Code Appeal Board", 
                "Civil Resolution Tribunal", 
                "Community Care and Assisted Living Appeal Board", 
                "Disciplinary and Professional Conduct Board", 
                "Employment and Assistance Appeal Board", 
                "Employment Standards Tribunal", 
                "Enviornmental Appeal Board", 
                "Expropriation Compensation Board", 
                "Financial Services Tribunal", 
                "Forest Appeals Commission", 
                "Forest Practices Board", 
                "Health Care Practitioners' Special Special Committee for Audit Hearings", 
                "Health Professions Review Board", 
                "Hospital Appeal Board", 
                "Industry Training Appeal Board", 
                "Labour Relations Board", 
                "Mental Health Review Board", 
                "Oli and Gas Appeal Tribunal", 
                "Property Assessment Appeal Board", 
                "Property Assessment Review Panels", 
                "Safety Standards Appeal Board", 
                "Surface Rights Board", 
                "Workers' Compensation Appeal Tribunal", 
                "Other"
            ]
        },
        {
            label: 'Regulatory Bodies',
            options: [
                "Applied Science Technologists and Technicians of BC", 
                "Architectural Institute of BC", 
                "Assayer Certification Board of Examiners", 
                "Association of BC Land Surveyors", 
                "Association of British Columbia Forest Professionals", 
                "Association of Professional Engineers and Geoscientists of BC", 
                "British Columbia Broiler Hatching Egg Commission", 
                "British Columbia Chicken Marketing Board", 
                "British Columbia College of Social Workers", 
                "British Columbia Cranberry Marketing Commission", 
                "British Columbia Egg Marketing Board", 
                "British Columbia Ferry Commission", 
                "British Columbia Hog Marketing Commission", 
                "British Columbia Institute of Agrologists", 
                "British Columbia Milk Marketing Board", 
                "British Columbia Securities Commission", 
                "British Columbia Teachers' Council", 
                "British Columbia Turkey Marketing Board", 
                "British Columbia Vegetable Marketing Commission", 
                "British Columbia Society of Landscape Architects", 
                "Board of Examiners of the British Columbia Registered Music Teachers Association", 
                "British Columbia Container Trucking Commissioner", 
                "Chartered Professional Accountants of British Columbia", 
                "College of Applied Biology", 
                "Consumer Protection BC", 
                "Emergency Medical Assistants Licensing Board", 
                "Insurance Council of British Columbia", 
                "Land Title and Survey Authority of British Columbia", 
                "Law Society of British Columbia", 
                "Notaries Public Board of Examiners", 
                "British Columbia College of Nurses and Midwives",
                "College of Chiropractors of British Columbia",
                "College of Dental Hygienists of British Columbia",
                "College of Dental Surgeons of British Columbia",
                "College of Dental Technicians of British Columbia",
                "College of Denturists of British Columbia",
                "College of Dietitians of British Columbia",
                "College of Massage Therapists of British Columbia",
                "College of Naturopathic Physicians of British Columbia",
                "College of Occupational Therapists of British Columbia",
                "College of Opticians of British Columbia",
                "College of Optometrists of British Columbia",
                "College of Pharmacists of British Columbia",
                "College of Physical Therapists of British Columbia",
                "College of Physicians and Surgeons of British Columbia",
                "College of Psychologists of British Columbia",
                "College of Speech & Hearing Health Professionals of BC",
                "College of Traditional Chinese Medicine Practioners and Acupuncturists of British Columbia",
                "College of Veterinarians of British Columbia",
                "Real Estate Errors and Omissions Insurance Corporation",
                "WorkSafeBC",
                "Vehicle Sales Authority of British Columbia"
            ]
        }  
    
    ];
    otherTribunalType = "";
    tribunalType = "";
    trialDurationDays = "";

    mounted() { 
        this.dataReady = false; 
        this.manualSummaryInfo = this.form1Info;
        this.extractInfo();
        this.dataReady = true;            
    }

    public extractInfo(){

        this.trialDurationDays = this.form1Info.trialDurationDays?this.form1Info.trialDurationDays:"";

        if (this.manualSummaryInfo.tribunalType?.trim().length>0){

            if (this.tribunalTypes[0].options.includes(this.manualSummaryInfo.tribunalType) || this.tribunalTypes[1].options.includes(this.manualSummaryInfo.tribunalType)){
                this.tribunalType = this.manualSummaryInfo.tribunalType;
                this.otherTribunalType = '';            
            } else {
                this.tribunalType = 'Other';
                this.otherTribunalType = this.manualSummaryInfo.tribunalType;            
            }
        } else {
            this.tribunalType = '';
        }

    }

    public displayResults(){
        this.$emit('displayResults');
    }

    public update(){ 
              
        const form1 = this.manualSummaryInfo;
        form1.trialDurationDays = this.trialDurationDays; 
        if (this.tribunalType == 'Other'){
            form1.tribunalType = this.otherTribunalType;
        } else {
            form1.tribunalType = this.tribunalType;
        }
        
        if ((this.manualNorm || this.manualNTrib) && form1.lowerCourtRegistryId){
            const selectedLocation: locationsInfoType = this.locationsInfo.filter(location=>location.id == form1.lowerCourtRegistryId)[0]
            form1.lowerCourtRegistryName = selectedLocation.name;
        }
          
        this.UpdateForm1Info(form1);
        this.recheckStates()
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
           
        return (date <= day);           
    }

    public recheckStates(){
        this.$emit('recheckStates')
    } 

}
